// Mock data for Morning Sunday Teer Result (frontend-only teaser)
// This will later be replaced with real backend API calls.

// ---- Storage helpers (persist mock edits in the browser) ----
const LS_KEYS = {
  results: "mst_results",
  common: "mst_common",
  previous: "mst_previous",
  homepage: "mst_homepage",
  auth: "mst_admin_auth",
  cred: "mst_admin_cred",
};

// Default previous results (latest date first). F/R and S/R two-digit numbers.
const defaultPrevious = [
  { id: "p1", date: "06-08-2026", fr: "87", sr: "56" },
  { id: "p2", date: "05-08-2026", fr: "30", sr: "43" },
  { id: "p3", date: "04-08-2026", fr: "25", sr: "73" },
  { id: "p4", date: "03-08-2026", fr: "16", sr: "69" },
  { id: "p5", date: "02-08-2026", fr: "22", sr: "77" },
  { id: "p6", date: "01-08-2026", fr: "43", sr: "54" },
  { id: "p7", date: "31-07-2026", fr: "42", sr: "32" },
  { id: "p8", date: "30-07-2026", fr: "67", sr: "36" },
  { id: "p9", date: "29-07-2026", fr: "20", sr: "32" },
  { id: "p10", date: "28-07-2026", fr: "44", sr: "60" },
  { id: "p11", date: "27-07-2026", fr: "48", sr: "74" },
  { id: "p12", date: "26-07-2026", fr: "16", sr: "92" },
  { id: "p13", date: "25-07-2026", fr: "58", sr: "27" },
  { id: "p14", date: "24-07-2026", fr: "69", sr: "17" },
  { id: "p15", date: "23-07-2026", fr: "46", sr: "82" },
  { id: "p16", date: "22-07-2026", fr: "79", sr: "05" },
  { id: "p17", date: "21-07-2026", fr: "51", sr: "38" },
  { id: "p18", date: "20-07-2026", fr: "10", sr: "64" },
  { id: "p19", date: "19-07-2026", fr: "56", sr: "27" },
  { id: "p20", date: "18-07-2026", fr: "92", sr: "86" },
];

// Homepage / today's result (SHILLONG). Times as per original.
const defaultHomepage = {
  date: "06-08-2026",
  city: "SHILLONG",
  frTime: "10:30 AM",
  srTime: "11:30 AM",
  fr: "87",
  sr: "56",
};

// Common number (SHILLONG) - two sets of Direct/House/Ending
const defaultCommon = {
  date: "06-08-2026",
  city: "SHILLONG",
  rows: [
    { direct: "55,20", house: "0", ending: "2" },
    { direct: "58", house: "4", ending: "8" },
  ],
  disclaimer:
    "The Morning Sunday Teer Common Number predictions provided above are generated purely through historical data calculations and mathematical observation of past outcomes.",
};

// Admin "Manage Result" entries (editable via admin panel)
const defaultResults = [...defaultPrevious];

function load(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (e) {
    return fallback;
  }
}
function save(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {}
}

// ---- Public mock API ----
export const mockApi = {
  keys: LS_KEYS,
  getHomepage: () => load(LS_KEYS.homepage, defaultHomepage),
  setHomepage: (data) => save(LS_KEYS.homepage, data),

  getCommon: () => load(LS_KEYS.common, defaultCommon),
  setCommon: (data) => save(LS_KEYS.common, data),

  getPrevious: () => load(LS_KEYS.previous, defaultPrevious),
  setPrevious: (list) => save(LS_KEYS.previous, list),

  getResults: () => load(LS_KEYS.results, defaultResults),
  setResults: (list) => save(LS_KEYS.results, list),

  // auth
  isLoggedIn: () => load(LS_KEYS.auth, false) === true,
  getCred: () => load(LS_KEYS.cred, { username: "admin", password: "admin123" }),
  login: (username, password) => {
    const cred = load(LS_KEYS.cred, { username: "admin", password: "admin123" });
    if (username === cred.username && password === cred.password) {
      save(LS_KEYS.auth, true);
      return true;
    }
    return false;
  },
  logout: () => save(LS_KEYS.auth, false),
  changePassword: (oldPass, newPass) => {
    const cred = load(LS_KEYS.cred, { username: "admin", password: "admin123" });
    if (oldPass !== cred.password) return false;
    save(LS_KEYS.cred, { ...cred, password: newPass });
    return true;
  },
};

// Dream number tables (static cultural data)
export const dreamTables = [
  {
    title: "1. Animals (Jantu) Targets",
    rows: [
      { symbol: "Tiger / Lion", direct: "09, 19, 99", house: "9", ending: "9" },
      { symbol: "Elephant", direct: "98, 89, 87", house: "9", ending: "8" },
      { symbol: "Dog", direct: "04, 44, 54, 64", house: "4", ending: "4" },
      { symbol: "Cat", direct: "17, 27, 37", house: "2", ending: "7" },
      { symbol: "Cow / Buffalo", direct: "12, 45, 54", house: "4", ending: "4" },
    ],
  },
  {
    title: "2. Birds & Insects (Pakshi/Kira) Targets",
    rows: [
      { symbol: "Eagle / Big Bird", direct: "02, 78, 99", house: "0", ending: "7" },
      { symbol: "Pigeon", direct: "04, 14, 24", house: "1", ending: "4" },
      { symbol: "Spider", direct: "08, 18, 28", house: "1", ending: "8" },
      { symbol: "Bee / Wasp", direct: "13, 23, 73", house: "7", ending: "3" },
      { symbol: "Butterfly", direct: "17, 37, 57", house: "5", ending: "7" },
    ],
  },
  {
    title: "3. Nature & Elements (Prakriti) Targets",
    rows: [
      { symbol: "Water / River", direct: "07, 14, 78", house: "3", ending: "4" },
      { symbol: "Fire / Spark", direct: "06, 12, 89", house: "1", ending: "2" },
      { symbol: "Big Tree", direct: "09, 29, 69", house: "2", ending: "9" },
      { symbol: "Heavy Rain", direct: "10, 20, 30", house: "1", ending: "0" },
      { symbol: "Mountain", direct: "08, 18, 88", house: "8", ending: "8" },
    ],
  },
  {
    title: "4. Human Actions (Kaam) Targets",
    rows: [
      { symbol: "Running", direct: "15, 25, 35", house: "2", ending: "5" },
      { symbol: "Swimming", direct: "11, 21, 31", house: "3", ending: "1" },
      { symbol: "Fighting / Quarrel", direct: "03, 13, 73", house: "5", ending: "3" },
      { symbol: "Bathing", direct: "08, 28, 98", house: "4", ending: "8" },
      { symbol: "Sleeping", direct: "00, 10, 20", house: "0", ending: "0" },
    ],
  },
  {
    title: "5. People & Relations (Log) Targets",
    rows: [
      { symbol: "Man / Male", direct: "26, 66, 94", house: "6", ending: "6" },
      { symbol: "Woman / Female", direct: "06, 56, 95", house: "5", ending: "6" },
      { symbol: "Baby / Child", direct: "01, 11, 21", house: "1", ending: "1" },
      { symbol: "Police", direct: "67, 78, 88", house: "8", ending: "7" },
      { symbol: "Bride / Wedding", direct: "14, 24, 74", house: "7", ending: "4" },
    ],
  },
  {
    title: "6. Spirits & Supernatural (Bhoot) Targets",
    rows: [
      { symbol: "Ghost / Spirit", direct: "09, 49, 99", house: "9", ending: "9" },
      { symbol: "Dead Body", direct: "04, 14, 44", house: "4", ending: "4" },
      { symbol: "Blood", direct: "37, 47, 77", house: "7", ending: "7" },
      { symbol: "Temple / Church", direct: "11, 22, 33", house: "1", ending: "2" },
      { symbol: "Priest / Monk", direct: "15, 25, 55", house: "5", ending: "5" },
    ],
  },
  {
    title: "7. Vehicles (Gaadi) Targets",
    rows: [
      { symbol: "Car", direct: "04, 64, 89", house: "4", ending: "8" },
      { symbol: "Train", direct: "59, 69, 98", house: "9", ending: "9" },
      { symbol: "Airplane", direct: "18, 68, 98", house: "9", ending: "8" },
      { symbol: "Bicycle", direct: "02, 12, 22", house: "2", ending: "2" },
      { symbol: "Boat", direct: "03, 13, 33", house: "3", ending: "3" },
    ],
  },
  {
    title: "8. Food & Drink (Khana) Targets",
    rows: [
      { symbol: "Rice / Grain", direct: "08, 18, 88", house: "8", ending: "8" },
      { symbol: "Banana", direct: "11, 51, 91", house: "1", ending: "6" },
      { symbol: "Fish", direct: "09, 46, 78", house: "4", ending: "7" },
      { symbol: "Meat", direct: "14, 24, 44", house: "4", ending: "4" },
      { symbol: "Tea / Milk", direct: "05, 15, 55", house: "5", ending: "5" },
    ],
  },
  {
    title: "9. Objects (Samaan) Targets",
    rows: [
      { symbol: "Money / Coins", direct: "08, 58, 86", house: "6", ending: "8" },
      { symbol: "Telephone", direct: "32, 94, 98", house: "9", ending: "6" },
      { symbol: "Book", direct: "45, 54, 64", house: "4", ending: "5" },
      { symbol: "Umbrella", direct: "01, 11, 71", house: "1", ending: "1" },
      { symbol: "Shoes", direct: "02, 22, 82", house: "2", ending: "2" },
    ],
  },
  {
    title: "10. Events (Ghatna) Targets",
    rows: [
      { symbol: "Accident", direct: "04, 14, 44", house: "4", ending: "4" },
      { symbol: "Festival / Party", direct: "15, 25, 75", house: "7", ending: "5" },
      { symbol: "Playing Sports", direct: "11, 21, 31", house: "2", ending: "1" },
      { symbol: "Crying", direct: "02, 12, 72", house: "7", ending: "2" },
      { symbol: "Dream Vision", direct: "17, 53, 83", house: "5", ending: "6" },
    ],
  },
];
